export const downloadTypeOptions = [
  { label: 'Пакет(технокад)', value: 'packageZIP' },
  { label: 'Схема', value: 'scheme' },
  { label: 'Подписанный пакет', value: 'packageZipWithSignature' },
];
